import { dataLayerSelectItem } from '../../Services/Gtm.service';

window.ObserveProductClickEvent = (gtmItemModel) => {
  dataLayerSelectItem([gtmItemModel]);
};
